import {
  useWSModalCustom,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { selectorTaxRateLabel } from "../../../shared/selectors/selectorTaxRateLabel";

type Props = {
  taxRate: number;
} & WSModalCustomProps<void>;

const exampleIncome = 1000;

export const ModalHowItWorks: React.FC<Props> = props => {
  const withholdings = exampleIncome * (props.taxRate / 100);
  const payout = exampleIncome - withholdings;

  return (
    <WSModal
      title="How it works"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Secondary",
            label: "Done",
            onClick: () => {
              props.onClose();
            }
          }
        ]
      }}
      {...props}
    >
      <WSList gap="L">
        <WSText.ParagraphSm color="gray500">
          When you receive a payment, here’s what to expect:
        </WSText.ParagraphSm>

        <WSInfoBox transparent>
          <ol>
            <li>
              <b>Invoice is paid by client</b>
              <ul>
                <li>
                  Let's use {formatMoney(exampleIncome, "USD")} as an example
                </li>
              </ul>
            </li>

            <li>
              <b>Wingspan receives payment from client </b>
              <ul>
                <li>
                  Your payout is automatically split (based on your withholdings
                  percentage of {selectorTaxRateLabel(props.taxRate)})
                </li>

                <ul>
                  <li>{formatMoney(payout, "USD")} (Payout_method)</li>
                  <li>
                    {formatMoney(withholdings, "USD")} (Your tax withholdings
                    account)
                  </li>
                </ul>
              </ul>
            </li>
          </ol>
        </WSInfoBox>

        <WSInfoBox>
          <p>
            <b>Your tax withholdings account</b>

            <ul>
              <li>FDIC insured up to $250,000</li>
              <li>Real-time balance tracking via our ledger system</li>
              <li>Withdraw at any time or stop withholding at any time</li>
              <li>Bank-level 256-bit encryption</li>
              <li>SOC 2 Type II certified infrastructure</li>
            </ul>
          </p>

          <p>
            <b>Security & control</b>

            <ul>
              <li>Two-factor authentication for all withdrawals</li>
              <li>Only you can authorize IRS payments</li>
              <li>Complete transaction history with balance snapshots</li>
              <li>You can pause or adjust withholding anytime</li>
              <li>Withdraw your funds at any time</li>
            </ul>
          </p>
        </WSInfoBox>
      </WSList>
    </WSModal>
  );
};

export const useModalHowItWorks = () => useWSModalCustom(ModalHowItWorks);
